// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file pickup_location_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { JobCategory, JobCategoryJson, JobType, JobTypeJson, LocationStatus, LocationStatusJson, PickupLocationType, PickupLocationTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { FileUpload, FileUploadJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { ListFilter, ListFilterJson, MessageResponseSchema, OrganizationLabelCreateSchema, OrganizationLabelListRequestSchema, OrganizationLabelListSchema, OrganizationLabelSchema, OrganizationLabelUpdateSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JobStop, JobStopJson } from "./job_pb";
import { file_job } from "./job_pb";
import type { PickupLocationCreateSchema, PickupLocationGroupCreateSchema, PickupLocationGroupListSchema, PickupLocationGroupSchema, PickupLocationGroupUpdateSchema, PickupLocationListSchema, PickupLocationSchema, PickupLocationUpdateSchema } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pickup_location_service.proto.
 */
export const file_pickup_location_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_file_upload, file_general, file_google_protobuf_timestamp, file_job, file_pickup_location]);

/**
 * @generated from message raccoonai.PickupLocationRequest
 */
export type PickupLocationRequest = Message<"raccoonai.PickupLocationRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationRequest
 */
export type PickupLocationRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationRequest.
 * Use `create(PickupLocationRequestSchema)` to create a new message.
 */
export const PickupLocationRequestSchema: GenMessage<PickupLocationRequest, {jsonType: PickupLocationRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 0);

/**
 * @generated from message raccoonai.PickupLocationListRequest
 */
export type PickupLocationListRequest = Message<"raccoonai.PickupLocationListRequest"> & {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_receiver_ids = 2 [json_name = "service_receiver_ids"];
   */
  serviceReceiverIds: bigint[];

  /**
   * Only pickup locations hosting container groups bound to these pickup location groups.
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 3 [json_name = "pickup_location_group_ids"];
   */
  pickupLocationGroupIds: bigint[];

  /**
   * Only pickup locations hosting container groups whose group binding carries this job type.
   *
   * @generated from field: optional raccoonai.JobType job_type = 4 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * Only pickup locations hosting container groups of these container types.
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * Only pickup locations hosting container groups whose contract prices a job
   * type of one of these categories (the container group's service schedule is
   * the fallback when the contract carries no tariff map).
   *
   * @generated from field: repeated raccoonai.JobCategory job_categories = 6 [json_name = "job_categories"];
   */
  jobCategories: JobCategory[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 7;
   */
  statuses: LocationStatus[];

  /**
   * @generated from field: optional string search = 8;
   */
  search: string;

  /**
   * Deprecated: filter by pickup_location_type_ids.
   *
   * @generated from field: repeated raccoonai.PickupLocationType types = 9 [deprecated = true];
   * @deprecated
   */
  types: PickupLocationType[];

  /**
   * No inheritance from the client's manager: a location with no manager_id matches nothing.
   *
   * @generated from field: repeated uint64 manager_ids = 11 [json_name = "manager_ids"];
   */
  managerIds: bigint[];

  /**
   * 0 matches locations with no type.
   *
   * @generated from field: repeated uint64 pickup_location_type_ids = 12 [json_name = "pickup_location_type_ids"];
   */
  pickupLocationTypeIds: bigint[];

  /**
   * facets: "status" (LocationStatus), "type" (PickupLocationType; deprecated, use
   * "pickup_location_type_id"), "pickup_location_type_id" (FacetCounts.id_counts, 0 = no type).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.PickupLocationListRequest
 */
export type PickupLocationListRequestJson = {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_receiver_ids = 2 [json_name = "service_receiver_ids"];
   */
  service_receiver_ids?: string[];

  /**
   * Only pickup locations hosting container groups bound to these pickup location groups.
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 3 [json_name = "pickup_location_group_ids"];
   */
  pickup_location_group_ids?: string[];

  /**
   * Only pickup locations hosting container groups whose group binding carries this job type.
   *
   * @generated from field: optional raccoonai.JobType job_type = 4 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * Only pickup locations hosting container groups of these container types.
   *
   * @generated from field: repeated uint64 container_type_ids = 5 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * Only pickup locations hosting container groups whose contract prices a job
   * type of one of these categories (the container group's service schedule is
   * the fallback when the contract carries no tariff map).
   *
   * @generated from field: repeated raccoonai.JobCategory job_categories = 6 [json_name = "job_categories"];
   */
  job_categories?: JobCategoryJson[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 7;
   */
  statuses?: LocationStatusJson[];

  /**
   * @generated from field: optional string search = 8;
   */
  search?: string;

  /**
   * Deprecated: filter by pickup_location_type_ids.
   *
   * @generated from field: repeated raccoonai.PickupLocationType types = 9 [deprecated = true];
   * @deprecated
   */
  types?: PickupLocationTypeJson[];

  /**
   * No inheritance from the client's manager: a location with no manager_id matches nothing.
   *
   * @generated from field: repeated uint64 manager_ids = 11 [json_name = "manager_ids"];
   */
  manager_ids?: string[];

  /**
   * 0 matches locations with no type.
   *
   * @generated from field: repeated uint64 pickup_location_type_ids = 12 [json_name = "pickup_location_type_ids"];
   */
  pickup_location_type_ids?: string[];

  /**
   * facets: "status" (LocationStatus), "type" (PickupLocationType; deprecated, use
   * "pickup_location_type_id"), "pickup_location_type_id" (FacetCounts.id_counts, 0 = no type).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.PickupLocationListRequest.
 * Use `create(PickupLocationListRequestSchema)` to create a new message.
 */
export const PickupLocationListRequestSchema: GenMessage<PickupLocationListRequest, {jsonType: PickupLocationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 1);

/**
 * @generated from message raccoonai.ContainerGroupJobLink
 */
export type ContainerGroupJobLink = Message<"raccoonai.ContainerGroupJobLink"> & {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;
};

/**
 * @generated from message raccoonai.ContainerGroupJobLink
 */
export type ContainerGroupJobLinkJson = {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;
};

/**
 * Describes the message raccoonai.ContainerGroupJobLink.
 * Use `create(ContainerGroupJobLinkSchema)` to create a new message.
 */
export const ContainerGroupJobLinkSchema: GenMessage<ContainerGroupJobLink, {jsonType: ContainerGroupJobLinkJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 2);

/**
 * @generated from message raccoonai.BindContainerGroupsRequest
 */
export type BindContainerGroupsRequest = Message<"raccoonai.BindContainerGroupsRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * @generated from field: repeated raccoonai.ContainerGroupJobLink links = 2;
   */
  links: ContainerGroupJobLink[];
};

/**
 * @generated from message raccoonai.BindContainerGroupsRequest
 */
export type BindContainerGroupsRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * @generated from field: repeated raccoonai.ContainerGroupJobLink links = 2;
   */
  links?: ContainerGroupJobLinkJson[];
};

/**
 * Describes the message raccoonai.BindContainerGroupsRequest.
 * Use `create(BindContainerGroupsRequestSchema)` to create a new message.
 */
export const BindContainerGroupsRequestSchema: GenMessage<BindContainerGroupsRequest, {jsonType: BindContainerGroupsRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 3);

/**
 * @generated from message raccoonai.RemoveContainerGroupRequest
 */
export type RemoveContainerGroupRequest = Message<"raccoonai.RemoveContainerGroupRequest"> & {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: required uint64 pickup_location_group_id = 2 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  jobType: JobType;
};

/**
 * @generated from message raccoonai.RemoveContainerGroupRequest
 */
export type RemoveContainerGroupRequestJson = {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: required uint64 pickup_location_group_id = 2 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;
};

/**
 * Describes the message raccoonai.RemoveContainerGroupRequest.
 * Use `create(RemoveContainerGroupRequestSchema)` to create a new message.
 */
export const RemoveContainerGroupRequestSchema: GenMessage<RemoveContainerGroupRequest, {jsonType: RemoveContainerGroupRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 4);

/**
 * @generated from message raccoonai.ReorderContainerGroupsRequest
 */
export type ReorderContainerGroupsRequest = Message<"raccoonai.ReorderContainerGroupsRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * Container group ids in the desired display order (full list).
   *
   * @generated from field: repeated uint64 container_group_ids = 2 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];
};

/**
 * @generated from message raccoonai.ReorderContainerGroupsRequest
 */
export type ReorderContainerGroupsRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * Container group ids in the desired display order (full list).
   *
   * @generated from field: repeated uint64 container_group_ids = 2 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];
};

/**
 * Describes the message raccoonai.ReorderContainerGroupsRequest.
 * Use `create(ReorderContainerGroupsRequestSchema)` to create a new message.
 */
export const ReorderContainerGroupsRequestSchema: GenMessage<ReorderContainerGroupsRequest, {jsonType: ReorderContainerGroupsRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 5);

/**
 * @generated from message raccoonai.PickupLocationPhotosRequest
 */
export type PickupLocationPhotosRequest = Message<"raccoonai.PickupLocationPhotosRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationPhotosRequest
 */
export type PickupLocationPhotosRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationPhotosRequest.
 * Use `create(PickupLocationPhotosRequestSchema)` to create a new message.
 */
export const PickupLocationPhotosRequestSchema: GenMessage<PickupLocationPhotosRequest, {jsonType: PickupLocationPhotosRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 6);

/**
 * @generated from message raccoonai.PickupLocationPhoto
 */
export type PickupLocationPhoto = Message<"raccoonai.PickupLocationPhoto"> & {
  /**
   * @generated from field: required raccoonai.FileUpload file_upload = 1 [json_name = "file_upload"];
   */
  fileUpload?: FileUpload;

  /**
   * @generated from field: optional string driver_first_name = 2 [json_name = "driver_first_name"];
   */
  driverFirstName: string;

  /**
   * @generated from field: optional string driver_last_name = 3 [json_name = "driver_last_name"];
   */
  driverLastName: string;
};

/**
 * @generated from message raccoonai.PickupLocationPhoto
 */
export type PickupLocationPhotoJson = {
  /**
   * @generated from field: required raccoonai.FileUpload file_upload = 1 [json_name = "file_upload"];
   */
  file_upload?: FileUploadJson;

  /**
   * @generated from field: optional string driver_first_name = 2 [json_name = "driver_first_name"];
   */
  driver_first_name?: string;

  /**
   * @generated from field: optional string driver_last_name = 3 [json_name = "driver_last_name"];
   */
  driver_last_name?: string;
};

/**
 * Describes the message raccoonai.PickupLocationPhoto.
 * Use `create(PickupLocationPhotoSchema)` to create a new message.
 */
export const PickupLocationPhotoSchema: GenMessage<PickupLocationPhoto, {jsonType: PickupLocationPhotoJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 7);

/**
 * @generated from message raccoonai.PickupLocationPhotoList
 */
export type PickupLocationPhotoList = Message<"raccoonai.PickupLocationPhotoList"> & {
  /**
   * @generated from field: repeated raccoonai.PickupLocationPhoto photos = 1;
   */
  photos: PickupLocationPhoto[];
};

/**
 * @generated from message raccoonai.PickupLocationPhotoList
 */
export type PickupLocationPhotoListJson = {
  /**
   * @generated from field: repeated raccoonai.PickupLocationPhoto photos = 1;
   */
  photos?: PickupLocationPhotoJson[];
};

/**
 * Describes the message raccoonai.PickupLocationPhotoList.
 * Use `create(PickupLocationPhotoListSchema)` to create a new message.
 */
export const PickupLocationPhotoListSchema: GenMessage<PickupLocationPhotoList, {jsonType: PickupLocationPhotoListJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 8);

/**
 * @generated from message raccoonai.PickupLocationListToContractRequest
 */
export type PickupLocationListToContractRequest = Message<"raccoonai.PickupLocationListToContractRequest"> & {
  /**
   * @generated from field: repeated uint64 pickup_location_ids = 1 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: required uint64 contract_id = 2 [json_name = "contract_id"];
   */
  contractId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationListToContractRequest
 */
export type PickupLocationListToContractRequestJson = {
  /**
   * @generated from field: repeated uint64 pickup_location_ids = 1 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: required uint64 contract_id = 2 [json_name = "contract_id"];
   */
  contract_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationListToContractRequest.
 * Use `create(PickupLocationListToContractRequestSchema)` to create a new message.
 */
export const PickupLocationListToContractRequestSchema: GenMessage<PickupLocationListToContractRequest, {jsonType: PickupLocationListToContractRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 9);

/**
 * @generated from message raccoonai.PickupLocationGroupRequest
 */
export type PickupLocationGroupRequest = Message<"raccoonai.PickupLocationGroupRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.PickupLocationGroupRequest
 */
export type PickupLocationGroupRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.PickupLocationGroupRequest.
 * Use `create(PickupLocationGroupRequestSchema)` to create a new message.
 */
export const PickupLocationGroupRequestSchema: GenMessage<PickupLocationGroupRequest, {jsonType: PickupLocationGroupRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 10);

/**
 * @generated from message raccoonai.PickupLocationGroupListRequest
 */
export type PickupLocationGroupListRequest = Message<"raccoonai.PickupLocationGroupListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * Only groups containing at least one container group owned by these organizations (service receivers).
   *
   * @generated from field: repeated uint64 service_receiver_ids = 2 [json_name = "service_receiver_ids"];
   */
  serviceReceiverIds: bigint[];

  /**
   * Only groups with a container group binding for this job type (combined with
   * service_receiver_ids: the same binding must satisfy both).
   *
   * @generated from field: optional raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * Only groups bound to one of these container groups; with job_type, by the same binding (the job form's route group select).
   *
   * @generated from field: repeated uint64 container_group_ids = 4 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.PickupLocationGroupListRequest
 */
export type PickupLocationGroupListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * Only groups containing at least one container group owned by these organizations (service receivers).
   *
   * @generated from field: repeated uint64 service_receiver_ids = 2 [json_name = "service_receiver_ids"];
   */
  service_receiver_ids?: string[];

  /**
   * Only groups with a container group binding for this job type (combined with
   * service_receiver_ids: the same binding must satisfy both).
   *
   * @generated from field: optional raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * Only groups bound to one of these container groups; with job_type, by the same binding (the job form's route group select).
   *
   * @generated from field: repeated uint64 container_group_ids = 4 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.PickupLocationGroupListRequest.
 * Use `create(PickupLocationGroupListRequestSchema)` to create a new message.
 */
export const PickupLocationGroupListRequestSchema: GenMessage<PickupLocationGroupListRequest, {jsonType: PickupLocationGroupListRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 11);

/**
 * @generated from message raccoonai.PreviewPickupLocationGroupJobsRequest
 */
export type PreviewPickupLocationGroupJobsRequest = Message<"raccoonai.PreviewPickupLocationGroupJobsRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * service day, Asia/Almaty
   *
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.PreviewPickupLocationGroupJobsRequest
 */
export type PreviewPickupLocationGroupJobsRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * service day, Asia/Almaty
   *
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: TimestampJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.PreviewPickupLocationGroupJobsRequest.
 * Use `create(PreviewPickupLocationGroupJobsRequestSchema)` to create a new message.
 */
export const PreviewPickupLocationGroupJobsRequestSchema: GenMessage<PreviewPickupLocationGroupJobsRequest, {jsonType: PreviewPickupLocationGroupJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 12);

/**
 * The group's work for `date`, in step_idx order, then window order. Read-only.
 *
 * @generated from message raccoonai.PickupLocationGroupJobsPreview
 */
export type PickupLocationGroupJobsPreview = Message<"raccoonai.PickupLocationGroupJobsPreview"> & {
  /**
   * What CreateRoutesFromStops accepts, ready to send back:
   * - one container group stop per schedule window the daily generator plans
   *   (schedule covers the day, contract prices the job type); `job` is set
   *   when an unrouted job of this group already covers the window, which it
   *   reuses;
   * - one job_id stop (with `job`) per other unrouted job of the group's links
   *   that day: manual jobs, or more jobs than windows.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 1;
   */
  stops: JobStop[];

  /**
   * Windows and jobs CreateRoutesFromStops would refuse, with `job` set: the
   * job is on a route or past CREATED, or the window's job belongs to another
   * group. Same forms as stops.
   *
   * @generated from field: repeated raccoonai.JobStop taken = 2;
   */
  taken: JobStop[];
};

/**
 * The group's work for `date`, in step_idx order, then window order. Read-only.
 *
 * @generated from message raccoonai.PickupLocationGroupJobsPreview
 */
export type PickupLocationGroupJobsPreviewJson = {
  /**
   * What CreateRoutesFromStops accepts, ready to send back:
   * - one container group stop per schedule window the daily generator plans
   *   (schedule covers the day, contract prices the job type); `job` is set
   *   when an unrouted job of this group already covers the window, which it
   *   reuses;
   * - one job_id stop (with `job`) per other unrouted job of the group's links
   *   that day: manual jobs, or more jobs than windows.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 1;
   */
  stops?: JobStopJson[];

  /**
   * Windows and jobs CreateRoutesFromStops would refuse, with `job` set: the
   * job is on a route or past CREATED, or the window's job belongs to another
   * group. Same forms as stops.
   *
   * @generated from field: repeated raccoonai.JobStop taken = 2;
   */
  taken?: JobStopJson[];
};

/**
 * Describes the message raccoonai.PickupLocationGroupJobsPreview.
 * Use `create(PickupLocationGroupJobsPreviewSchema)` to create a new message.
 */
export const PickupLocationGroupJobsPreviewSchema: GenMessage<PickupLocationGroupJobsPreview, {jsonType: PickupLocationGroupJobsPreviewJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 13);

/**
 * Replace-set: omitted contracts are unbound. BY_NORM contracts only — the
 * owner binding, pickup_location.contract_id, is not touched here.
 *
 * @generated from message raccoonai.SetPickupLocationContractsRequest
 */
export type SetPickupLocationContractsRequest = Message<"raccoonai.SetPickupLocationContractsRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: repeated uint64 contract_ids = 2 [json_name = "contract_ids"];
   */
  contractIds: bigint[];
};

/**
 * Replace-set: omitted contracts are unbound. BY_NORM contracts only — the
 * owner binding, pickup_location.contract_id, is not touched here.
 *
 * @generated from message raccoonai.SetPickupLocationContractsRequest
 */
export type SetPickupLocationContractsRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: repeated uint64 contract_ids = 2 [json_name = "contract_ids"];
   */
  contract_ids?: string[];
};

/**
 * Describes the message raccoonai.SetPickupLocationContractsRequest.
 * Use `create(SetPickupLocationContractsRequestSchema)` to create a new message.
 */
export const SetPickupLocationContractsRequestSchema: GenMessage<SetPickupLocationContractsRequest, {jsonType: SetPickupLocationContractsRequestJson}> = /*@__PURE__*/
  messageDesc(file_pickup_location_service, 14);

/**
 * @generated from service raccoonai.PickupLocationService
 */
export const PickupLocationService: GenService<{
  /**
   * Pickup Location operations
   *
   * @generated from rpc raccoonai.PickupLocationService.CreatePickupLocation
   */
  createPickupLocation: {
    methodKind: "unary";
    input: typeof PickupLocationCreateSchema;
    output: typeof PickupLocationSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.GetPickupLocationById
   */
  getPickupLocationById: {
    methodKind: "unary";
    input: typeof PickupLocationRequestSchema;
    output: typeof PickupLocationSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.UpdatePickupLocation
   */
  updatePickupLocation: {
    methodKind: "unary";
    input: typeof PickupLocationUpdateSchema;
    output: typeof PickupLocationSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.DeletePickupLocation
   */
  deletePickupLocation: {
    methodKind: "unary";
    input: typeof PickupLocationRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.ListPickupLocations
   */
  listPickupLocations: {
    methodKind: "unary";
    input: typeof PickupLocationListRequestSchema;
    output: typeof PickupLocationListSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.ListPickupLocationPhotos
   */
  listPickupLocationPhotos: {
    methodKind: "unary";
    input: typeof PickupLocationPhotosRequestSchema;
    output: typeof PickupLocationPhotoListSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.SetPickupLocationContracts
   */
  setPickupLocationContracts: {
    methodKind: "unary";
    input: typeof SetPickupLocationContractsRequestSchema;
    output: typeof PickupLocationSchema;
  },
  /**
   * @todeprecate
   *
   * @generated from rpc raccoonai.PickupLocationService.BindPickupLocationListToContract
   */
  bindPickupLocationListToContract: {
    methodKind: "unary";
    input: typeof PickupLocationListToContractRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Pickup location types. Archive / restore with Update(status).
   *
   * @generated from rpc raccoonai.PickupLocationService.CreatePickupLocationType
   */
  createPickupLocationType: {
    methodKind: "unary";
    input: typeof OrganizationLabelCreateSchema;
    output: typeof OrganizationLabelSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.UpdatePickupLocationType
   */
  updatePickupLocationType: {
    methodKind: "unary";
    input: typeof OrganizationLabelUpdateSchema;
    output: typeof OrganizationLabelSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.ListPickupLocationTypes
   */
  listPickupLocationTypes: {
    methodKind: "unary";
    input: typeof OrganizationLabelListRequestSchema;
    output: typeof OrganizationLabelListSchema;
  },
  /**
   * Pickup Location Group operations
   *
   * @generated from rpc raccoonai.PickupLocationService.CreatePickupLocationGroup
   */
  createPickupLocationGroup: {
    methodKind: "unary";
    input: typeof PickupLocationGroupCreateSchema;
    output: typeof PickupLocationGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.GetPickupLocationGroupById
   */
  getPickupLocationGroupById: {
    methodKind: "unary";
    input: typeof PickupLocationGroupRequestSchema;
    output: typeof PickupLocationGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.ListPickupLocationGroups
   */
  listPickupLocationGroups: {
    methodKind: "unary";
    input: typeof PickupLocationGroupListRequestSchema;
    output: typeof PickupLocationGroupListSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.UpdatePickupLocationGroup
   */
  updatePickupLocationGroup: {
    methodKind: "unary";
    input: typeof PickupLocationGroupUpdateSchema;
    output: typeof PickupLocationGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.DeletePickupLocationGroup
   */
  deletePickupLocationGroup: {
    methodKind: "unary";
    input: typeof PickupLocationGroupRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.PreviewPickupLocationGroupJobs
   */
  previewPickupLocationGroupJobs: {
    methodKind: "unary";
    input: typeof PreviewPickupLocationGroupJobsRequestSchema;
    output: typeof PickupLocationGroupJobsPreviewSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.BindContainerGroupsToPickupLocationGroup
   */
  bindContainerGroupsToPickupLocationGroup: {
    methodKind: "unary";
    input: typeof BindContainerGroupsRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.UnbindContainerGroupFromPickupLocationGroup
   */
  unbindContainerGroupFromPickupLocationGroup: {
    methodKind: "unary";
    input: typeof RemoveContainerGroupRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.PickupLocationService.ReorderContainerGroupsInPickupLocationGroup
   */
  reorderContainerGroupsInPickupLocationGroup: {
    methodKind: "unary";
    input: typeof ReorderContainerGroupsRequestSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pickup_location_service, 0);

